import { ReferralTrackingParams } from "./types";

// No client-side NHS formatting — backend searches both spaced and unspaced formats
const normalizeSearch = (search: string): string => search.trim();

const buildQueryString = (params: ReferralTrackingParams): string => {
  const searchParams = new URLSearchParams();

  if (params.offset !== undefined) searchParams.set("offset", String(params.offset));
  if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
  if (params.sort_by) searchParams.set("sort_by", params.sort_by);
  if (params.sort_order) searchParams.set("sort_order", params.sort_order);
  if (params.search) searchParams.set("search", normalizeSearch(params.search));
  if (params.date_from) searchParams.set("date_from", params.date_from);
  if (params.date_to) searchParams.set("date_to", params.date_to);

  if (params.filters) {
    for (const [key, values] of Object.entries(params.filters)) {
      if (values.length > 0) {
        searchParams.set(`filters[${key}]`, values.join(","));
      }
    }
  }

  const qs = searchParams.toString();
  return qs ? `?${qs}` : "";
};

export default buildQueryString;
